var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKpisperformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#0DA9D5",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3301 13.8364L21.8645 9.74545L20.9656 9L17.3301 12.2727L15.4325 10.4727L14.5137 11.2909L17.3301 13.8364ZM12.5356 24.6143C12.8152 24.8714 13.1534 25 13.5501 25C13.9467 25 14.2863 24.8727 14.5688 24.6182C14.8513 24.3636 14.9925 24.0558 14.9925 23.6948C14.9925 23.3337 14.8527 23.0246 14.573 22.7675C14.2934 22.5104 13.9552 22.3818 13.5585 22.3818C13.1619 22.3818 12.8223 22.5091 12.5398 22.7636C12.2573 23.0182 12.1161 23.326 12.1161 23.6871C12.1161 24.0481 12.2559 24.3572 12.5356 24.6143ZM20.6055 24.6143C20.8851 24.8714 21.2233 25 21.62 25C22.0167 25 22.3562 24.8727 22.6387 24.6182C22.9212 24.3636 23.0624 24.0558 23.0624 23.6948C23.0624 23.3337 22.9226 23.0246 22.6429 22.7675C22.3633 22.5104 22.0251 22.3818 21.6285 22.3818C21.2318 22.3818 20.8922 22.5091 20.6097 22.7636C20.3273 23.0182 20.186 23.326 20.186 23.6871C20.186 24.0481 20.3258 24.3572 20.6055 24.6143ZM9 10.4545V11.5454H10.5581L13.5144 17.4364L12.236 19.5818C12.0096 19.9576 12.0273 20.3273 12.2892 20.6909C12.5512 21.0545 12.9329 21.2364 13.4345 21.2364H23.0624V20.1455H13.2547L14.3733 18.2545H20.4257C20.7038 18.2545 20.9597 18.1848 21.1936 18.0455C21.4274 17.9061 21.6176 17.7212 21.764 17.4909L25 11.9818H23.6617L20.4598 17.0727H14.7129L11.3171 10.4545H9Z",
    fill: "#0DA9D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKpisperformance);
export default __webpack_public_path__ + "static/media/icon-kpisperformance.a4658c4e.svg";
export { ForwardRef as ReactComponent };